import { render, staticRenderFns } from "./createAppointment.vue?vue&type=template&id=0cf01248&scoped=true"
import script from "./createAppointment.vue?vue&type=script&lang=js"
export * from "./createAppointment.vue?vue&type=script&lang=js"
import style0 from "./createAppointment.vue?vue&type=style&index=0&id=0cf01248&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf01248",
  null
  
)

export default component.exports